module.exports = __webpack_public_path__ + "static/img/kcqd.773e2434.png";